import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class SidebarFacets extends UcoastEl {
  static htmlSelector = 'sidebar-facets'

  inputs: NodeListOf<HTMLInputElement>

  constructor() {
    super()

    this.inputs = q.rl('input', this)
    this.inputs.forEach(input => {
      input.addEventListener('change', this.onChangeFilter.bind(this))
    })
  }

  onChangeFilter(e: Event) {
    const target = e.currentTarget as HTMLInputElement
    if(!target) return
    if(target.value == '') this.inputs.forEach(input => input.checked = false)
    const facetForm = document.querySelector('[data-uc-facet-form]') as HTMLFormElement
    if (!facetForm) return
    facetForm.querySelector('.mobile-facets__checkbox')?.dispatchEvent(new InputEvent('input', { bubbles: true }))
  }
}


export class FacetSort extends UcoastEl {
  static htmlSelector = 'facet-sort'
  static closeAnimationMs = 240

  select?: HTMLSelectElement
  details?: HTMLDetailsElement
  summary?: HTMLElement
  input?: HTMLInputElement
  label?: HTMLElement
  options: HTMLButtonElement[]
  onDocumentClick?: (event: MouseEvent) => void
  closeTimeoutId?: number

  constructor() {
    super()

    this.options = Array.from(q.rl('[data-uc-facet-sort-option]', this))
    this.select = q.os('select', this)

    if (this.select) {
      this.select.addEventListener('change', this.onChangeFilter.bind(this))
      return
    }

    this.details = q.os('[data-uc-facet-sort]', this)
    this.summary = q.os('.facet-sort-dropdown__summary', this)
    this.input = q.os('[data-uc-facet-sort-input]', this)
    this.label = q.os('[data-uc-facet-sort-label]', this)

    this.summary?.addEventListener('click', this.onSummaryClick.bind(this))

    this.options.forEach(option => {
      option.addEventListener('click', this.onOptionClick.bind(this))
    })

    this.onDocumentClick = this.closeOnOutsideClick.bind(this)
    document.addEventListener('click', this.onDocumentClick)
  }

  override disconnectedCallback() {
    if (this.closeTimeoutId) window.clearTimeout(this.closeTimeoutId)
    if (this.onDocumentClick) {
      document.removeEventListener('click', this.onDocumentClick)
    }
  }

  onSummaryClick(event: Event) {
    event.preventDefault()
    if (!this.details) return

    if (this.details.hasAttribute('open')) {
      this.closeDropdown()
      return
    }

    if (this.closeTimeoutId) window.clearTimeout(this.closeTimeoutId)
    this.details.removeAttribute('data-uc-closing')
    this.details.setAttribute('open', '')
  }

  closeDropdown() {
    if (!this.details) return
    if (!this.details.hasAttribute('open')) return
    if (this.details.hasAttribute('data-uc-closing')) return

    this.details.setAttribute('data-uc-closing', '')
    if (this.closeTimeoutId) window.clearTimeout(this.closeTimeoutId)
    this.closeTimeoutId = window.setTimeout(() => {
      this.details?.removeAttribute('open')
      this.details?.removeAttribute('data-uc-closing')
    }, FacetSort.closeAnimationMs)
  }

  closeOnOutsideClick(event: MouseEvent) {
    if (!this.details || !this.details.hasAttribute('open')) return
    const target = q.rt(event)
    if (this.contains(target)) return
    this.closeDropdown()
  }

  onOptionClick(event: Event) {
    const currentTarget = q.rct(event)
    const value = q.ra(currentTarget, 'data-value')
    const label = q.ra(currentTarget, 'data-label')

    if (this.input) this.input.value = value
    if (this.label) this.label.textContent = label

    this.options.forEach((option) => {
      const isSelected = q.ra(option, 'data-value') === value
      option.classList.toggle('is-active', isSelected)
      option.setAttribute('aria-selected', `${isSelected}`)
    })

    this.closeDropdown()

    const closestForm = this.closest('form')
    if (closestForm && this.input) {
      this.input.dispatchEvent(new InputEvent('input', { bubbles: true }))
      return
    }

    this.syncMobileSort(value)
  }

  syncMobileSort(value: string) {
    const sortInputs = document.querySelectorAll('.facets-sort__input') as NodeListOf<HTMLInputElement> | null
    if (!sortInputs) return
    sortInputs.forEach(sort => {
      sort.checked = sort.value == value
    })
    const facetForm = document.querySelector('[data-uc-facet-form]') as HTMLFormElement
    if (!facetForm) return
    facetForm.querySelector('.mobile-facets__checkbox')?.dispatchEvent(new InputEvent('input', { bubbles: true }))
  }

  onChangeFilter(e: Event) {
    if (!this.select) return
    const sortInputs = document.querySelectorAll('.facets-sort__input') as NodeListOf<HTMLInputElement> | null
    if (!sortInputs) return
    sortInputs.forEach(sort => {
      sort.checked = sort.value == this.select.value
    })
    const facetForm = document.querySelector('[data-uc-facet-form]') as HTMLFormElement
    if (!facetForm) return
    facetForm.querySelector('.mobile-facets__checkbox')?.dispatchEvent(new InputEvent('input', { bubbles: true }))
  }
}
